import CreatePasswordBlock from './CreatePasswordBlock';
import { CreatePasswordBlockProps, CreatePasswordBlockValueProps } from './types';

export type { CreatePasswordBlockProps, CreatePasswordBlockValueProps };
export default CreatePasswordBlock;
